import React from 'react';
import ItemWithTooltip from './ItemWithTooltip';
import { TimelineMedicationRequestOnlyIcon } from '../../../Icons';

interface Props {
  item: any;
}
const MedicationRequestOnlyItem = ({ item }: Props) => {
  return (
    <ItemWithTooltip item={item}>
      <div className="mt-2" />
      <TimelineMedicationRequestOnlyIcon />
    </ItemWithTooltip>
  );
};

export default MedicationRequestOnlyItem;
